﻿require('./../scss/style.scss');

import FilterList from './project/FilterList.js';
import OrangeCookie from './project/OrangeCookie.js';
import ReCaptcha from './project/ReCaptcha.js';
import CareFinder from './project/CareFinder.js';

var $masonry,
    $carousel,
    $scrollbut,
    $footerForm,
    paddingTop,
    maxpos,
    headerHeight;

var $document, $window, router, globalData, debug;
$(function () {
    $document = $(document);
    $window = $(window);
    globalData = $('body').data();

    debug = (true
        && globalData.islocal != null
        && globalData.islocal === true);

    //router = new Router(debug);

    //router
    //    .registerTransient("ReCaptcha")
    //    .registerSingleton("FilterList")
    //    .registerTransient("OrangeCookie");

    //router
    //    .dom(".OrangeCookie", "OrangeCookie")
    //    .dom(".ReCaptcha", "ReCaptcha")
    //    .dom(".FilterList", "FilterList");

    if ($(".smartArchive").length > 0) {
        $(".smartArchive a").on("click", function (e) {
            var link = $(this);
            var listItem = $(link.parent());
            var subList = listItem.children("ul");

            if (subList.length > 0) {
                e.preventDefault();

                if (listItem.hasClass("open")) {
                    listItem.removeClass("open");
                    subList.hide();
                }
                else {
                    listItem.addClass("open");
                    subList.show();
                }
            }
        });
    }

    $(".accordion li").on("click", "> a", function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    var $head = $('header.sticky');
    $head.addClass('fixed');
    headerHeight = $head.height();
    $head.removeClass('fixed');

    var offset = Foundation.utils.is_large_up() ? 47 : 0;

    var hash = window.location.hash;
    if (hash != "") {
        window.location.hash = "";
        var hashEl = $(hash);
        hashEl.blur().parent().addClass('active');
        $('html, body').animate({
            scrollTop: hashEl.offset().top - headerHeight + offset
        }, 500);
    }

    var $centraCount = $('#centraCount');
    var counter = parseInt($centraCount.text());
    var $filterBlock = $('#filterCentra');
    var $allFilters = $filterBlock.find('select, input[type=checkbox]');
    var $centrumList = $('#centrumList');
    var $centrumItems = $centrumList.find('>li');
    var $emptyText = $('#centraEmptyText');
    $centrumItems.addClass('regionShow');
    if ($filterBlock.length && $centrumList.length) {
        checkFilters($allFilters, $centrumItems);
        $allFilters.change(function () {
            checkFilters($allFilters, $centrumItems);
            $('html, body').animate({ scrollTop: $centraCount.offset().top - headerHeight + offset }, 500);
            counter = $centrumItems.filter(':visible').length;
            $centraCount.text(counter);
            if (counter == 0) {
                $emptyText.show();
            } else {
                $emptyText.hide();
            }
        });
    }

    $window.load(function () {
        $carousel = $(".regular-carousel");
        $masonry = $('.masonry');
        $carousel.each(function () {
            var $this = $(this);
            var hasMasonry = $this.hasClass('masonry');
            var childrenLength = $this.children().length;
            var desktopItems = hasMasonry ? 2 : 1.25;
            var itemMargin = hasMasonry ? 10 : 0;
            var slideByNumber = hasMasonry ? childrenLength > 3 ? 2 : 1 : 1;
            var isLoopedSmall = childrenLength > 1 ? true : false;
            var isLoopedDesktop = hasMasonry ? childrenLength >= 3 ? true : false : childrenLength > 1 ? true : false;
            $this.on('initialize.owl.carousel initialized.owl.carousel' + 'resize.owl.carousel resized.owl.carousel', function (e) {
                if (hasMasonry) setTimeout(function () { $this.height($this.find('.h2').first().height()) }, 200);
                /*if (e.type == "initialized") window.slimmage.checkResponsiveImages();*/
            });
            var owlOptions = {
                center: false,
                items: 1,
                margin: itemMargin,
                loop: isLoopedSmall,
                rewind: false,
                autoplay: isLoopedSmall,
                mouseDrag: false,
                pullDrag: false,
                touchDrag: isLoopedSmall,
                autoplayHoverPause: true,
                autoplaySpeed: 700,
                autoplayTimeout: 10000,
                navSpeed: 1000,
                nav: isLoopedSmall,
                navText: ["Volgende", "Vorige"],
                dots: false,
                responsive: {
                    1026: {
                        items: desktopItems,
                        slideBy: slideByNumber,
                        loop: isLoopedDesktop,
                        nav: isLoopedDesktop,
                    }
                },
                autoHeight: true,
            };
            $this.owlCarousel(owlOptions);
        });

        var $widgetCarousels = $('.widget-carousel');
        if ($widgetCarousels) {
            $widgetCarousels.each(function () {
                var $this = $(this);
                var $counter = $this.siblings('.owl-counter');

                var counter = (event) => {
                    if (!$counter) return;
                    var slides = event.relatedTarget;
                    $counter.text(slides.relative(slides.current()) + 1 + '/' + slides.items().length);
                }

                var stagePadding = $this.hasClass('agenda-carousel') ? 24 : 0;
                var responsive = $this.hasClass('gallery-carousel') ?
                    {
                        640: {
                            items: 2,
                        }
                    } :
                    {};

                var owlOptions = {
                    center: true,
                    items: 1,
                    margin: 10,
                    nav: true,
                    dots: false,
                    navText: ['Vorige', 'Volgende'],
                    autoHeight: true,
                    onInitialized: counter,
                    onChanged: counter,
                    stagePadding: stagePadding,
                    responsive: responsive,
                };

                $this.owlCarousel(owlOptions);
            })
        }

        $scrollbut = $('.stickyBottom .stickyButton');
        $footerForm = $(".footerContactForm");
        var $footerFormBox = $(".contactForm");
        paddingTop = parseInt($footerForm.parents('footer').css('paddingTop'));
        var marginbottom = parseInt($footerForm.parents('footer').find('.footer-inner').outerHeight());
        maxpos = $(document).height() - (marginbottom + paddingTop + headerHeight);
        $scrollbut.parent().addClass('initialized');
        $footerFormBox.css("bottom", marginbottom);
        toggleContactForm();

        $(window).resize(function () {
            marginbottom = parseInt($footerForm.parents('footer').find('.footer-inner').outerHeight());
            $footerFormBox.css("bottom", marginbottom);
        });

        let galleryCounter = 0;

        $('.gallery-trigger').on('click', (event) => {
            let trigger = event.target.closest('.gallery-trigger');
            galleryCounter = trigger.dataset.counter ? trigger.dataset.counter : 0;
        })

        $(document).on('opened.fndtn.reveal', '[data-reveal]', (event) => {
            if (event.target.getAttribute('id') === 'reveal-gallery') {
                $('.reveal-gallery-carousel').owlCarousel('refresh');
                if (galleryCounter) $('.reveal-gallery-carousel').trigger('to.owl.carousel', galleryCounter);
            }
        });
    });

    window.addEventListener('DOMContentLoaded', (event) => {
        let orangeCookie = document.querySelector('.OrangeCookie');
        if (orangeCookie) new OrangeCookie(orangeCookie)

        let filterList = document.querySelector('.FilterList');
        if (filterList) new FilterList(filterList)

        let reCaptchas = document.querySelectorAll('.ReCaptcha');
        if (reCaptchas && reCaptchas.length) {
            reCaptchas.forEach(reCaptcha => {
                new ReCaptcha(reCaptcha);
            })
        }

        let careFinder = document.getElementById('careFinder');
        if (careFinder) new CareFinder(careFinder)

        
        

        let gradeContainer = document.getElementById('grade-container');
        let zknWidget = document.querySelector('.BeoordelingsZorgkaartNederland');

        if (gradeContainer && zknWidget) {
            if (document.querySelector('.zkn-widget__p')) {
                setGradeContainer(gradeContainer, document.querySelector('.zkn-widget__p').innerText);
            }
            else {
                var observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (document.querySelector('.zkn-widget__p')) {
                            setGradeContainer(gradeContainer, document.querySelector('.zkn-widget__p').innerText);
                            observer.disconnect();
                        }
                    });
                });

                observer.observe(zknWidget, { childList: true, subtree: true });
            }
        }
    });
});

function setGradeContainer(containerNode, gradeSentence) {
    let gradeSentenceArray = gradeSentence.split(' ');
    let grade = gradeSentenceArray[gradeSentenceArray.length - 1].slice(0, -1);
    let amount = gradeSentenceArray.find(word => parseInt(word));
    if (grade && amount) {
        document.getElementById('grade-container-grade').innerText = grade;
        document.getElementById('grade-container-amount').innerText = '(' + amount + ')';
        containerNode.style.display = 'flex';
    }
}

function toggleContactForm() {
    $scrollbut.click(function (e) {
        e.preventDefault();
        var $btn = $(e.target);
        $footerForm.slideToggle();
        $btn.closest("a").toggleClass('open');
        $btn.parent().toggleClass('formOpen');
        $("body").toggleClass('noscroll');

    });
    if ($(this).scrollTop() + $(this).height() >= maxpos) {
        $scrollbut.parent().addClass('unfixed');
    }
    $(window).on('scroll', function () {
        if ($(this).scrollTop() + $(this).height() >= maxpos) {
            $scrollbut.parent().addClass('unfixed');
        } else {
            $scrollbut.parent().removeClass('unfixed');
        }
    });
}

function checkFilters($allFilters, $centrumItems) {
    $centrumItems.show();
    $allFilters.each(function () {
        var $this = $(this);
        if (this.tagName.toLowerCase() == "select") {
            if ($this.val() != "") {
                $centrumItems.not($('.' + $this.val())).hide();
            }
        } else if ($this.attr('type') == "checkbox") {
            if ($this.prop("checked")) {
                $centrumItems.not($('.' + $this.val())).hide();
            }
        }
    });
}

function isUndefined(obj) {
    return (typeof obj === "undefined");
}

function isDefined(obj) {
    return (!isUndefined(obj));
}

function hasValue(obj) {
    return (
        obj != null &&
        isDefined(obj) &&
        obj !== ""
    );
}